import { Skeleton } from '@/components/atoms/skeleton';

export function RouteLoadingSkeleton() {
  return (
    <div className="flex min-h-full flex-col">
      <header className="bg-dp-header-color flex min-h-[88px] w-full items-center py-4 px-16">
        <Skeleton height={24} width={200} />
      </header>
      <div className="mx-auto flex w-full flex-col gap-4 px-4 py-8">
        <div className="flex flex-row flex-wrap items-center gap-4">
          <Skeleton height={40} width={360} />
          <Skeleton height={36} width={140} />
        </div>
        <Skeleton height={220} width="100%" />
        <Skeleton height={220} width="100%" />
      </div>
    </div>
  );
}
